import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetListOfProjects = () => {
  const [projects, setProjects] = useState([]);
  const [projectMap, setProjectMap] = useState();
  const [page, setPage] = useState(1);
  const [totalLength, setTotalLength] = useState(0);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const getProjects = async () => {
    if (search === "") {
      setIsLoading(true);
    }
    try {
      let data = await TLinkApi.get("/projects/list");
      setProjects(data.data);
      setTotalLength(data.data.totalLenght);
      setIsLoading(false);
      let projectsMap = [];
      data?.data?.map((value) => {
        projectsMap[value.id] = value.name;
        return true;
      });
      setProjectMap(projectsMap);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getProjects();
    // eslint-disable-next-line
  }, [page, search]);
  return {
    projects,
    getProjects,
    projectMap,
    isLoading,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
  };
};

export default GetListOfProjects;
